// @ts-nocheck
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export const ErrorTooltip = withStyles(() => ({
  popper: { zIndex: '999999', cursor: 'pointer' },
  tooltip: {
    backgroundColor: 'rgb(251,215,213)',
    color: 'rgb(253,41,41)',
    fontSize: 12,
  },
  arrow: { color: 'rgb(251,215,213)' },
}))(Tooltip);
